import React from 'react';

import { flagStyles } from '../settings';

const SvgDO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1416px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDO;
